import React from 'react';
import Layout from '../components/layout/layout';
import SEO from '../components/seo';
import './index.styles.css';
import Hero from '../components/home/hero/hero';
import OurClients from '../components/home/our-clients/our-clients';
import WhyInfluencers from '../components/home/why-influencers/why-influencers';
import Results from '../components/home/results/results';
import CampaignPhases from '../components/home/campaign-phases/campaign-phases';
import VideoModule from '../components/home/video-module/video-module';
import Cta from '../components/home/cta/cta';

const IndexPage = () => (
  <Layout>
    <SEO title='Home' />
    <Hero />
    <OurClients />
    <WhyInfluencers />
    <Results />
    <CampaignPhases />
    <VideoModule />
    <Cta />
  </Layout>
);

export default IndexPage;
